import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { RestService } from '../service/rest.service';

@Injectable({ providedIn: 'root' })
export class RootRedirectGuard implements CanActivate {
  constructor(private rest: RestService, private router: Router) { }

  canActivate(): boolean | UrlTree {
    // A construction subdomain (e.g. isc.aoa.edu.eg) resolves to its own
    // construction page from the hostname instead of a numeric id in the URL.
    const constructionId = this.rest.getConstructionIdByHost();
    if (constructionId) {
      // The Quality Assurance Center (id 11, subdomain eqac) has its own page.
      if (constructionId === 11) {
        return this.router.parseUrl('/eqac');
      }
      return this.router.parseUrl('/constrction/' + constructionId);
    }
    if (this.rest.isAcademyHost()) {
      return this.router.parseUrl('/home');
    }
    return true;
  }
}
